import { getAngledRectangleWidth as f } from "./CartesianUtils.js";
import { getEveryNthWithCondition as n } from "./getEveryNthWithCondition.js";
function m(t, r, i) {
  var e = {
    width: t.width + r.width,
    height: t.height + r.height
  };
  return f(e, i);
}
function c(t, r, i) {
  var e = i === "width", h = t.x, d = t.y, u = t.width, a = t.height;
  return r === 1 ? {
    start: e ? h : d,
    end: e ? h + u : d + a
  } : {
    start: e ? h + u : d + a,
    end: e ? h : d
  };
}
function W(t, r, i, e, h) {
  if (t * r < t * e || t * r > t * h)
    return !1;
  var d = i();
  return t * (r - t * d / 2 - e) >= 0 && t * (r + t * d / 2 - h) <= 0;
}
function p(t, r) {
  return n(t, r + 1);
}
export {
  m as getAngledTickWidth,
  p as getNumberIntervalTicks,
  c as getTickBoundaries,
  W as isVisible
};
